import React, { useEffect, useState } from 'react'
import { Close as CloseIcon } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import { FeatureCollection, GeoJsonProperties, Geometry, Polygon } from 'geojson'

import { GeoPoint } from '~types'

import MapBoxWithControls from './MapBoxWithControls'

interface MapBoxPolygonFilterProps {
  onSearch: (coordinates: GeoPoint[]) => void
  onClose: () => void
  initialPosition?: GeoPoint
  pointsToDraw?: GeoPoint[]
}

const MapBoxPolygonFilter: React.FC<MapBoxPolygonFilterProps> = ({
  onSearch,
  onClose,
  initialPosition = undefined,
  pointsToDraw = [],
}) => {
  const [drawnFeatures, setDrawnFeatures] = useState<FeatureCollection>()

  const handleDrawComplete = (features: FeatureCollection<Geometry, GeoJsonProperties>): void => {
    if (features.features.length > 0) {
      setDrawnFeatures(features)
    } else {
      setDrawnFeatures(undefined)
    }
  }

  const handleSearch = (): void => {
    if (drawnFeatures && drawnFeatures.features.length > 0) {
      const geometry = drawnFeatures.features[0].geometry
      if (geometry.type === 'Polygon') {
        const polygonGeometry = geometry as Polygon
        const coordinates = polygonGeometry.coordinates[0]
        const geoPointCoordinates = coordinates.map((coord) => ({ lon: coord[0], lat: coord[1] }))
        onSearch(geoPointCoordinates)
      } else {
        console.error('Drawn feature is not a polygon')
      }
    } else {
      onSearch([])
    }
  }

  useEffect(() => {
    handleSearch()
  }, [drawnFeatures])

  return (
    <Box sx={{ padding: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, marginBottom: 2 }}>
        <Box className='flex-v-align' gap={1} sx={{ mb: 1 }}>
          <Typography variant='h6'>Geographic Filter</Typography>
          <IconButton onClick={onClose} sx={{ bgcolor: 'background.paper' }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>
      <Box sx={{ position: 'relative', width: '100%', height: '400px' }}>
        <MapBoxWithControls
          id='contact-filter-map'
          initialPosition={initialPosition}
          showDrawControls={true}
          enableMultipleSelection={false}
          onDrawComplete={handleDrawComplete}
          pointsToDraw={pointsToDraw}
          fitMapToPoints={false}
          height='100%'
        />
      </Box>
    </Box>
  )
}

export default MapBoxPolygonFilter
